import { Text, View } from "react-native";
import React from "react";
import { AppColors } from "../../utility/AppColors";
export function Badge({ title }) {
  return (
    <View
      style={{
        position: "absolute",
        top: 20,
        right: -22,
        backgroundColor: "#000000",
        width: 100,
        height: 22,
        transform: [{ rotate: "45deg" }],
        zIndex: 10,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Text
        style={{
          color: AppColors.white,
          fontSize: 12, // Font size for readability
          fontWeight: "bold", // Bold font for emphasis
        }}
      >
        {title}
      </Text>
    </View>
  );
}
